export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novaLinha: {
    pt: 'Novo Segmento',
    en: 'New Segment',
    de: 'Neuer Segment',
    es: 'Nuevo Segmento',
  },

};